export default __webpack_public_path__ + "static/media/AvenirNextW04-Regular.6be251c0.woff";